module.exports = __webpack_public_path__ + "media/images/default/shared/footer/bg-line-lg-8afd34f3443c9c14c8e29e4bd6f0eea2.svg";